import service from '../apihttp'
import config from '@/assets/config.json'

//运营工具--列表
export function toolList(data) {
    const url = config.brandHttps.api + '/merchant/merchant/tool/list'
    return service.get(url, data)
}
//运营工具--创建
export function toolCreate(data) {
    const url = config.brandHttps.api + '/admin/administer/tool/create'
    return service.post(url, data)
}
//运营工具--编辑
export function toolEdit(data) {
    const url = config.brandHttps.api + '/admin/administer/tool/edit'
    return service.put(url, data)
}
//套餐--下拉
export function packageselect(data) {
    const url = config.brandHttps.api + '/admin/administer/tool/select'
    return service.get(url, data)
}
//套餐--列表
export function packageList(data) {
    const url = config.brandHttps.api + '/merchant/merchant/tool/scheme/list'
    return service.get(url, data)
}
//套餐--活动下拉
export function packageSelect(data) {
    const url = config.brandHttps.api + '/admin/users/rebatel/select'
    return service.get(url, data)
}

//套餐--运营工具
export function optSelect(data) {
    const url = config.brandHttps.api + '/admin/administer/tool/select'
    return service.get(url, data)
}
//套餐--创建
export function packageCreate(data) {
    const url = config.brandHttps.api + '/admin/administer/tool/scheme/create'
    return service.post(url, data)
}

//套餐--编辑
export function packageEdit(data) {
    const url = config.brandHttps.api + '/admin/administer/tool/scheme/edit'
    return service.put(url, data)
}
// 套餐购买 
export function payCreate(data) {
    const url = config.brandHttps.api + '/merchant/merchant/order/qrcode'
    return service.post(url, data)
}
//工具订单/admin/administer/tool/buy/listexport 
export function toolOrder(data) {
    const url = config.brandHttps.api + '/admin/administer/tool/buy/list'
    return service.get(url, data)
}
//剩余次数
export function toolNumner(data) {
    const url = config.brandHttps.api + '/merchant/users/opt/activate/activate'
    return service.get(url, data)
}
//订单状态修改
export function orederStatus(data) {
    const url = config.brandHttps.api + '/admin/administer/tool/buy/edit'
    return service.put(url, data)
}

//获取支付二维码
export function apishopPayment(data) {
    const url = config.shopHttps.api + `/apishop/payment/pay/${data.id}`
    return service.get(url, data)
}

//查询支付结果
export function getPayQuery(data) {
    const url = config.brandHttps.api + `/pay/query/${data.id}`
    return service.get(url, data)
}